module.exports = __webpack_public_path__ + "img/airasiafood.c2169b9c.jpeg";